import logo from './logo.svg';
import './App.css';
import Dashboard from './component/Dashboard';
import Attendancemaster from './component/Attendancemaster';
import { Route, Routes } from 'react-router-dom';
import Attendtabledata from './component/Attendtabledata';



function App() {
  return (<>
   <Routes>
    <Route path='/' exact  element={ <Dashboard></Dashboard>} ></Route> 
    <Route  path='/attendance' element={<Attendancemaster></Attendancemaster>} ></Route> 
    <Route  path='/attendancetable' element={<Attendtabledata></Attendtabledata>} ></Route> 
   </Routes>

   </>
  );
}

export default App;
